import axios from 'axios';
import { apiUrls } from '@/constant/configure';
import sessionStore from '@/store/modules/sessionStore';
import { getAnonymousToken, refreshToken, removeAnonymousToken, signOutSession } from '@/services/auth.service';
import checkExpireTime from '@/utils/checkExpireTime';
import { isEmbedded, requestEmbedToken } from '@/utils/embed';

const token = sessionStore.getState()?.accessToken;
// console.log('%c token for init', 'color:red;', token);

axios.defaults.withCredentials = true;
const api = axios.create({
    baseURL: apiUrls.manager,
});

api.defaults.headers.common['Authorization'] = !!token ? `Bearer ${token}` : undefined;

async function getUserToken() {
    try {
        const { accessToken, expiresIn } = sessionStore.getState();
        const isTokenLive = !!accessToken ? checkExpireTime(expiresIn) : false;

        if (isTokenLive) {
            return {
                accessToken: accessToken,
                expiresIn: expiresIn,
            };
        } else {
            return {
                accessToken: '',
                expiresIn: '',
            };
        }
    } catch (e) {
        return {
            accessToken: '',
            expiresIn: '',
        };
    }
}

// getUserToken().catch(r => r)

async function setApiHeader(token?: string) {
    const { accessToken } = await getUserToken();
    token = token || accessToken;

    api.defaults.headers.common['Authorization'] = !!token ? `Bearer ${token}` : `Bearer ${await getAnonymousToken()}`;
}

api.interceptors.request.use(
    async (config) => {
        // const source = axios.CancelToken.source()
        // config.cancelToken = source.token;
        // setTimeout(() => {
        //     source.cancel('over 2000ms time out')
        // }, 2000)
        // const {accessToken} = await getUserToken();
        //
        // if (!config?.headers?.Authorization) {
        //     // console.log(await getDefaultToken());
        //     config.headers.Authorization = !!accessToken ? `Bearer ${accessToken}` : `Bearer ${await getAnonymousToken()}`;
        //
        //     console.log('%c excepted-token', 'color:purple;', config?.headers?.Authorization)
        // }

        return config;
    },
    async (error) => {
        await Promise.reject(error);
    },
);

let retryCnt = 0;

api.interceptors.response.use(
    async function (res) {
        if (res.status === 205) {
            // access_token 기간 만료 시,
            removeAnonymousToken();

            console.log('tttt-1');

            const { updateToken, clearSession } = sessionStore.getState();
            try {
                // 글로벌 소듀 안에 끼워 넣은 창은 갱신 쿠키를 못 쓸 수 있어 부모 창에서 새 토큰을 받는다 (src/utils/embed.ts)
                const renew = isEmbedded() ? requestEmbedToken : refreshToken;
                const accessToken = await renew()
                    .then(async (r) => {
                        const { accessToken, expiresIn } = r;
                        updateToken(accessToken, expiresIn);

                        return r.accessToken;
                    })
                    .catch(async (e) => {
                        if (e.status === 403 || e.status === 500) {
                            clearSession();
                            return await getAnonymousToken();
                        } else {
                            throw e;
                        }
                    });
                const { config } = res;

                await setApiHeader(!!accessToken ? accessToken : undefined);

                retryCnt++;

                if (retryCnt < 3) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                    return await api(config);
                } else {
                    retryCnt = 0;
                }
            } catch (e: any) {
                // if (e.status === 403) throw e;
                //
                // console.log('tttt-2')
                //
                // console.error(e);
                // // removeAnonymousToken();
                // toast.error('로그인이 만료되었습니다.', {
                //     toastId: 'session-out-toast',
                // });
                // // router.navigate('/logout');
                //
                // if (await checkRefreshToken()) {
                //     router.navigate('/logout');
                // } else {
                //     router.navigate('/login');
                // }
                throw e;
            }
        }

        return res;
    },
    async function (err) {
        const { conf: conf, response } = err;
        // if (axios.isCancel(err)) {
        //     return Promise.reject(new Error('Request timed out'));
        // }
        if (response.status === 403) {
            const reqUrl = response.config?.url;

            if (reqUrl === '/auth/web/refreshToken') {
                // router.navigate('/login', {
                //     replace: true,
                // })
                await signOutSession();
            }
            console.log('res-403', { conf, response });
        }

        return Promise.reject(response || err);
    },
);

export default api;
